import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useEffect} from "react";
import {toast} from "@/components";
import {deleteAccountPagoMovil} from "../../services/wallet/accounts";

const useDeleteAccPagoMovil = () => {
  const queryClient = useQueryClient();
  const {isError, isPending, isSuccess, error, mutate} = useMutation({
    mutationKey: ["deleteMobileAccount"],
    mutationFn: deleteAccountPagoMovil,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ["userMobileAccount"]});
    },
  });

  useEffect(() => {
    if (isSuccess) {
      toast.success({
        title: "Cuenta eliminada correctamente",
      });
    }
  }, [isSuccess]);

  return {
    isErrorDelete: isError,
    isPendingDelete: isPending,
    isSuccessDelete: isSuccess,
    errorDelete: error,
    deleteAcc: mutate,
  };
};

export default useDeleteAccPagoMovil;
